import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useHostContext } from 'src/core/hooks/useHostContext';
import { QueryKeys } from 'src/core/router/constants';
import { DataHubService } from 'src/core/services/datahub';
import { ClickCreateModuleSchema } from 'src/core/services/datahub/schemas/modules/clickAnalyticsTabSchema';
import { ViewModuleCreateSchema } from 'src/core/services/datahub/schemas/modules/viewModuleCreateSchema';
import { useWizardContext } from 'src/modules/modules/hooks/useWizardContext';
import { Button } from 'src/shared/components/button';
import { DrawerHelper } from 'src/shared/components/drawer/helper';
import { Routes } from 'src/shared/constants/routes';
export const Footer = ({ onCloseDrawer, isLoading, isUpdate, isSubmitDisabled, isPaidModule, isExtraModule }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { product } = useHostContext();
    const { isLastStep, isFirstStep, goToNextStep, goToPreviousStep } = useWizardContext();
    function getModuleType() {
        if (isPaidModule)
            return 'PAID';
        if (isExtraModule)
            return 'EXTRA';
        return 'MAIN';
    }
    function redirectToPaidModuleFlow() {
        onCloseDrawer();
        const navigateToPaidModule = () => {
            navigate({
                pathname: Routes.ManagePaidAdditionalModule,
                search: `?${QueryKeys.ExtraPaid}=true`
            });
        };
        DrawerHelper.listenerOnClose(navigateToPaidModule);
    }
    function next() {
        DataHubService.sendEvent({
            schema: new ViewModuleCreateSchema({
                arrivedFrom: window.location.href,
                moduleType: getModuleType()
            })
        });
        if (isPaidModule) {
            redirectToPaidModuleFlow();
            return;
        }
        goToNextStep();
    }
    function submitDatahubEvent() {
        DataHubService.sendEvent({
            schema: new ClickCreateModuleSchema({
                productId: product.id,
                pathUrl: location.pathname
            })
        });
    }
    return (_jsxs(_Fragment, { children: [!isFirstStep && (_jsx(Button, { variation: "secondary", className: "w-full sm:w-auto", onClick: goToPreviousStep, children: t('general.back') })), isLastStep && (_jsx(Button, { type: "submit", loading: isLoading, formId: "module-form", onClick: submitDatahubEvent, className: "w-full sm:w-auto", disabled: isSubmitDisabled, children: t(isUpdate ? 'general.save' : 'modules.create_module') })), !isLastStep && (_jsx(Button, { className: "w-full sm:w-auto", onClick: next, children: t('general.next') }))] }));
};
